import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportDateRangeOptionComponent } from '../../../shared/components/report-date-range-option/report-date-range-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedDateRangeOptionComponent } from '../../../shared/components/report-applied-date-range-option/report-applied-date-range-option.component';

@Component({
    templateUrl: './partner-portal-match-reports.component.html',
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportDateRangeOptionComponent,
              ReportDetailsTemplateDirective,
              ReportAppliedDateRangeOptionComponent]
})
export class PartnerPortalMatchReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/partner_capture_reports`;
  reportsCountUrl = `${environment.captureApi.url}/partner_capture_reports/count`;

  filtersForm = this.formBuilder.group({
    verifiedDate: [null],
  });
}
